<template>
  <div class="other-nat-record">
    <ph-tabs
      v-model="active"
      :list="[
        { name: '我的记录', id: '0' },
        { name: '手动查询', id: '1' }
      ]"
      @tabClick="tabChange"
    />
    <div
      v-if="active === '0'"
      @click="showPickerCards = true"
      class="other-nat-record-card"
    >
      <div>卡号查询</div>
      <div>
        {{ baseInfo.cardNo }}
        <van-icon name="arrow-down" />
      </div>
    </div>
    <div class="other-nat-record-list">
      <ph-empty v-if="!recordList.length && active === '0'" bgcolor="white" />
      <div
        v-if="active === '1' && !manualList.length"
        style="margin:4rem 1rem 1rem 0"
      >
        <van-field
          v-model="name"
          label-class="label-title"
          label="姓名"
          input-align="right"
          placeholder="请输入"
        />
        <van-field
          v-model="idCard"
          label-class="label-title"
          label="身份证号"
          placeholder="请输入"
          input-align="right"
        />
        <ph-button @click="searchClick()" style="margin-top: 1rem;"
          >立即查询</ph-button
        >
      </div>
      <div
        v-for="(item, index) in recordList"
        v-else
        :key="index"
        class="other-nat-record-list-item"
      >
        <div class="other-nat-record-list-item-header">
          信息登记时间
          <div>
            {{ item.createTime }}
          </div>
        </div>
        <div class="other-nat-record-list-item-content">
          <div class="other-nat-record-list-item-content-hospital">
            <div style="display: flex;align-items: center;">
              <img :src="require('@assets/icon_hospital.png')" alt="" />
              龙岩人民医院
            </div>
            <div style="text-align: center;">
              <div :style="`color: ${item.stateColor};`">
                {{ item.stateStr }}
              </div>
              <span style="color: gray;">{{ item.stateDescript }}</span>
            </div>
          </div>
          <div>
            <div>
              <div><span>姓名：</span>{{ item.name }}</div>
              <div><span>卡号：</span>{{ item.cardNo }}</div>
              <div><span>手机号：</span>{{ item.phone }}</div>
              <div><span>证件号：</span>{{ item.idCard }}</div>
              <div><span>采样地点：</span>{{ item.cjd }}</div>
              <div><span>挂号id:</span>{{ item.qrcodeStr }}</div>
              <div><span>费用：</span>{{ item.money }}元 已支付</div>
            </div>
            <img
              v-if="item.payStatus == '0'"
              :src="require('@/assets/ic_nat_unpay.png')"
              alt=""
              style="width: 3rem;"
            />
          </div>
        </div>
        <div class="other-nat-record-list-item-bottom">
          <div @click="showQrcode(item)" style="border-right: 1px solid white;">
            {{ item.hsStatus !== "b" ? "二维码" : "立即开单" }}
          </div>
          <div @click="gotoDetail(item)">
            查看报告
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showPickerCards" position="bottom">
      <van-picker
        :columns="getCardList"
        @confirm="cardListConfirm"
        @cancel="showPickerCards = false"
        show-toolbar
      />
    </van-popup>
    <van-popup
      v-model="showCode"
      style="padding:1rem 0;font-size:1rem;text-align:center"
    >
      请凭此二维码到收费处打印核酸条码
      <div @click="showCode = false" style="text-align: center">
        <VueQrcode :value="qrcodeStr" :options="{ width: 320 }" />
        {{ qrcodeStr }}
      </div>
    </van-popup>
  </div>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  components: { VueQrcode },
  data() {
    return {
      cardNo: "123456",
      cardList: [],
      currentCard: 0,
      showPickerCards: false,
      recordList: [],
      showCode: false,
      qrcodeStr: "",
      active: "0",
      manualList: [],
      name: "",
      idCard: ""
    };
  },
  computed: {
    getJobs() {
      return this.professions.map(item => {
        return item.itemName;
      });
    },
    getSubJobs() {
      if (this.jobsId > -1 && this.professions[this.jobsId].children) {
        return this.professions[this.jobsId].children.map(item => {
          return item.itemName;
        });
      }
      return [];
    },
    getCardList() {
      return this.cardList.map(item => {
        return item.cardNo;
      });
    },
    baseInfo() {
      if (this.cardList.length) {
        return this.cardList[this.currentCard];
      }
      return {};
    }
  },
  created() {
    this.openId = this.$route.query.openId;
    if (this.openId) {
      this.getcardlist();
    } else {
      this.active = "1";
    }
    // axios
    //   .post("/palmhospitalWebService/queryEcard", {
    //     openId: this.openId
    //   })
    //   .then(res => {
    //     this.cardList = res.data.entity;
    //     for (var index in res) {
    //       if (res[index].flag == "1") {
    //         this.currentCard = index;
    //         break;
    //       }
    //     }
    //   })
  },
  methods: {
    loadData() {
      this.$http
        .post(this.$api.TEST_GET_QUERY, {
          openId: this.openId,
          cardNo: this.baseInfo.cardNo
        })
        .then(res => {
          this.recordList = res.map(item => {
            let stateStr = "";
            let stateColor = "";
            let stateDescript = "";
            switch (item.hsStatus) {
              case "a":
                stateStr = "待开单";
                stateColor = "black";
                stateDescript = "请您等待系统开单";
                break;
              case "b":
                stateStr = "开单失败";
                stateColor = "red";
                stateDescript = "点击左下角开单";
                break;
              case "c":
                stateStr = "开单成功";
                stateColor = "green";
                stateDescript = "请关注报告进度";
                break;
              default:
                break;
            }
            return {
              ...item,
              stateStr,
              stateColor,
              stateDescript,
              yjdjh: item.yjdjh ? item.yjdjh.split("-")[0] : "",
              qrcodeStr: item.yjdjh ? item.yjdjh.split("-")[1] : ""
            };
          });
          if (!this.recordList.length) {
            this.active = "1";
          }
        });
    },
    getcardlist() {
      this.$http
        .post(this.$api.TEST_CARD_LIST, {
          openId: this.openId
        })
        .then(res => {
          if (res && res.length) {
            this.cardList = res;
            this.loadData();
          } else {
            this.$phdialog
              .confirm({
                message:
                  "未查询到你线上开单的记录,请手动输入您的身份证号，姓名查询！",
                confirmButtonText: "确认"
              })
              .then(() => {
                this.active = "1";
              })
              .catch(() => {});
          }
        });
    },
    searchClick() {
      this.$http
        .post(this.$api.TEST_GET_MANUAL_LIST, {
          openId: this.openId,
          idCard: this.idCard,
          name: this.name
        })
        .then(res => {
          if (res.length) {
            this.active = "0";
            this.recordList = res.map(item => {
              let stateStr = "";
              let stateColor = "";
              let stateDescript = "";
              switch (item.hsStatus) {
                case "a":
                  stateStr = "待开单";
                  stateColor = "black";
                  stateDescript = "请您等待系统开单";
                  break;
                case "b":
                  stateStr = "开单失败";
                  stateColor = "red";
                  stateDescript = "点击左下角开单";
                  break;
                case "c":
                  stateStr = "开单成功";
                  stateColor = "green";
                  stateDescript = "请关注报告进度";
                  break;
                default:
                  break;
              }
              return {
                ...item,
                stateStr,
                stateColor,
                stateDescript,
                yjdjh: item.yjdjh ? item.yjdjh.split("-")[0] : "",
                qrcodeStr: item.yjdjh ? item.yjdjh.split("-")[1] : ""
              };
            });
          } else {
            this.$toast(
              "未查询到你线上开单的记录，请确认您的身份证号，姓名是否正确！"
            );
          }
        });
    },
    tabChange() {
      if (this.active === "0") {
        if (!this.openId) {
          alert("请完善查询信息！");
          this.active = "1";
        } else {
          this.getcardlist();
        }
      } else {
      }
    },
    gotoDetail(item) {
      if (item.payStatus == "0") {
        window.location.href = `http://fjsdsrmyyweixin.191cn.com/palmhospitalWebService/pay?cardType=${item.cardType}&cardNo=${item.cardNo}&name=${item.name}&idCard=${item.idCard}`;
        return;
      }
      if (item.yjdjh) {
        this.$router.push({
          name: "nucleic-acid-test-report-detail",
          query: {
            id: item.yjdjh
          }
        });
      } else {
        this.$toast("报告正在生成中。。");
      }
    },
    showQrcode(item) {
      if (item.hsStatus == "b") {
        // 重新开单
        this.$http
          .post(this.$api.TEST_REOPEN, {
            outTradeNo: item.outTradeNo,
            openId: item.openId
          })
          .then(() => {
            this.loadData();
          });
      } else {
        // 显示二维码
        this.qrcodeStr = item.qrcodeStr;
        if (this.qrcodeStr === "") {
          this.$toast("二维码正在生成中");
        } else {
          this.showCode = true;
        }
      }
    },
    cardListConfirm(_, id) {
      this.currentCard = id;
      this.showPickerCards = false;
      this.loadData();
    }
  }
};
</script>

<style lang="less">
.other-nat-record {
  &-card {
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin: 0.5rem;
    font-size: 0.9rem;
    border: 2px solid @primary-blue;

    &-title {
      border-right: 2px solid @primary-blue;
    }
    div {
      padding: 0.5rem;
    }
    i {
      margin-left: 0.5rem;
      vertical-align: middle;
    }
  }

  &-list-item {
    margin: 1rem;

    &-header {
      display: flex;
      justify-content: space-between;
      padding: 0.8rem 1rem;
      color: white;
      font-size: 0.85rem;
      background: @primary-blue;
      border-radius: 1rem 1rem 0 0;
    }
    &-content {
      padding: 0.2rem 1rem;
      font-size: 0.9rem;
      border-right: 1px solid #d3d3d3;
      border-left: 1px solid #d3d3d3;

      &-hospital {
        display: flex;
        justify-content: space-between;
        font-weight: 500;

        span {
          font-weight: 350 !important;
          font-size: 0.75rem;
        }
      }

      > div {
        display: flex;
        align-items: center;
      }

      span {
        font-weight: 500;
      }

      img {
        width: 2.5rem;
        margin-right: 0.2rem;
      }
    }

    &-bottom {
      display: flex;
      justify-content: space-between;
      padding: 0.1rem 0;
      color: white;
      line-height: 2rem;
      text-align: center;
      background: @primary-blue;
      border-radius: 0 0 1rem 1rem;

      div {
        width: 50%;
      }
    }
  }
}
</style>
